module.exports = __webpack_public_path__ + "img/pic-4.13ba9d16.png";